/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  KillswitchCapabilityKey,
  KillswitchCapabilityKey$outboundSchema,
} from "./killswitchcapabilitykey.js";
import {
  KillswitchSchedule,
  KillswitchSchedule$Outbound,
  KillswitchSchedule$outboundSchema,
} from "./killswitchschedule.js";
import {
  KillswitchScope,
  KillswitchScope$Outbound,
  KillswitchScope$outboundSchema,
} from "./killswitchscope.js";

export type KillswitchCreateRequest = {
  externalNote: string;
  internalNote: string;
  operationId: string;
  schedule: KillswitchSchedule;
  scope: KillswitchScope;
  userId: string;
  capabilityKey: KillswitchCapabilityKey;
};

/** @internal */
export type KillswitchCreateRequest$Outbound = {
  external_note: string;
  internal_note: string;
  operation_id: string;
  schedule: KillswitchSchedule$Outbound;
  scope: KillswitchScope$Outbound;
  user_id: string;
  capability_key: string;
};

/** @internal */
export const KillswitchCreateRequest$outboundSchema: z.ZodMiniType<
  KillswitchCreateRequest$Outbound,
  KillswitchCreateRequest
> = z.pipe(
  z.object({
    externalNote: z.string(),
    internalNote: z.string(),
    operationId: z.string(),
    schedule: KillswitchSchedule$outboundSchema,
    scope: KillswitchScope$outboundSchema,
    userId: z.string(),
    capabilityKey: KillswitchCapabilityKey$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      externalNote: "external_note",
      internalNote: "internal_note",
      operationId: "operation_id",
      userId: "user_id",
      capabilityKey: "capability_key",
    });
  }),
);

export function killswitchCreateRequestToJSON(
  killswitchCreateRequest: KillswitchCreateRequest,
): string {
  return JSON.stringify(
    KillswitchCreateRequest$outboundSchema.parse(killswitchCreateRequest),
  );
}
